import { render, staticRenderFns } from "./BrandNewRetailers.vue?vue&type=template&id=6bf7f686&scoped=true&lang=pug"
import script from "./BrandNewRetailers.vue?vue&type=script&lang=js"
export * from "./BrandNewRetailers.vue?vue&type=script&lang=js"
import style0 from "./BrandNewRetailers.vue?vue&type=style&index=0&id=6bf7f686&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf7f686",
  null
  
)

export default component.exports